import { Injectable } from '@angular/core';

import { MyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { ReBetAvailabilityService } from './../components/re-bet/re-bet-visibility.service';

@Injectable()
export class StadiumBetsVisibilityService {
    constructor(
        private mybetsConfig: MyBetsConfig,
        private reBetAvailability: ReBetAvailabilityService,
    ) {}

    showArchivedBets(listType: BetslipListType | null): boolean {
        return this.mybetsConfig.isArchivedBetsEnabled && (listType === BetslipListType.Settled || listType === BetslipListType.Open);
    }

    showTransactionBets(listType: BetslipListType | null): boolean {
        return this.mybetsConfig.isTransactionBetsEnabled && (listType === BetslipListType.Settled || listType === BetslipListType.Open);
    }

    showReBetHelpBox(listType: BetslipListType | null): boolean {
        return listType !== null && this.reBetAvailability.isHelpBoxAvailable(listType);
    }
}
